var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "Default profile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#e2e8f0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 48,
    r: 24,
    fill: "#94a3b8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94a3b8",
    d: "M24 112c0-22.091 17.909-40 40-40s40 17.909 40 40v4H24v-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserAvatar);
export default __webpack_public_path__ + "static/media/default-user-avatar.010091d90b58b328bd5fe76ed418681c.svg";
export { ForwardRef as ReactComponent };